<template>
  <div v-if="reportRuntimeDialog.visible">
    <div class="dialog-report" v-show="reportRuntimeDialog.visible">
      <div class="full" :class="{'hideClose':!hasClose}">
           <span class="close" v-if="hasClose" @click="reportRuntimeDialog.visible=false">X</span>
           <report-runtime v-if="reportRuntimeDialog.visible&&reportRuntimeDialog.type==='report'"
           :id="reportRuntimeDialog.id" @closeFlagChange="closeFlagChange" @closeDialog="getCloseDialog"></report-runtime>
      </div>
    </div>
  </div>
</template>

<script>
import ReportRuntime from '@/components/report/runtime/report-runtime.vue'
export default {
  name: 'DialogReportRuntime',
  props: ['reportRuntimeDialog'],
  data () {
    return {
      hasClose: true
    }
  },
  components: {
    ReportRuntime
  },
  methods: {
    getCloseDialog (type) {
      this.reportRuntimeDialog.visible = false
      // 当在报表执行页的按钮操作结束时,需要对当前页面的数据进行刷新
      if (type === 'comfirm' && location.href.includes('report-runtime')) {
        this.$emit('goSearch')
      } else if (type === 'process' && (location.href.includes('report-runtime') || location.href.includes('ProcessDoingtasks'))) {
        this.$emit('goSearch')
      }
    },
    closeFlagChange (type) {
      this.hasClose = type
    }
  }
}
</script>
<style lang="scss" >
.dialog-report {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 201;
  background-color: #fff;

  > div {
    width: 100%;
    height: calc(100% - 34px);

    &.full {
      width: 100%;
      height: 99%;
      position: relative;

      .close {
        position: absolute;
        right: 10px;
        top: 0;
        cursor: pointer;
        z-index: 201;
        color: #ADAFB0;

        &:hover {
          color: red;
        }
      }
    }

  }
  .hideClose{
    .report-design-preview{
      padding-top: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/dialog-report-runtime.vue